var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_nft"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 3.33433,
    y: 6.6665,
    width: 13.3333,
    height: 7.77778,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6612 15V4.99999L10.0009 0L1.34065 4.99999L1.34065 15L10.0009 20L18.6612 15ZM7.77929 7.25657V12.674H6.5519L4.59444 9.82774H4.56269V12.674H3.09194V7.25657H4.34049L6.26622 10.0923H6.30854V7.25657H7.77929ZM8.47499 12.674V7.25657H12.2841V8.44163H9.94573V9.37276H12.0513V10.5578H9.94573V12.674H8.47499ZM12.677 7.25657H17.3855V8.44163H15.756V12.674H14.3064V8.44163H12.677V7.25657Z",
    fill: "#555555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNft);
export default __webpack_public_path__ + "static/media/ic_nft.8d1442b553c2bb9963752ba97bee6010.svg";
export { ForwardRef as ReactComponent };